module.exports = __webpack_public_path__ + "media/newstyle/images/logo-americanas-color-0668aaf6f177e9bb7f23d6d3d0fc92eb.png";